import React, { useEffect, useState } from "react";
// import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth"; // TODO: Refactor with Supabase Auth
import { useNavigate } from "react-router-dom";
// import { doc, getDoc } from 'firebase/firestore'; // TODO: Refactor with Supabase DB
// import { firestore } from '../firebaseConfig'; // Firebase config removed

const MagicLinkSignin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const handleSignIn = async () => {
      // TODO: Refactor below logic with Supabase Auth/DB or remove if not applicable
      /*
      const auth = getAuth();

      if (!isSignInWithEmailLink(auth, window.location.href)) {
        setError("Lien de connexion invalide.");
        return;
      }

      let email = window.localStorage.getItem("emailForSignIn");
      if (!email) {
        email = window.prompt("Veuillez confirmer votre email pour vous connecter");
      }

      try {
        // 1. Sign in with the magic link
        await signInWithEmailLink(auth, email, window.location.href);

        // 2. Try to read Firestore doc
        const userDoc = await getDoc(doc(firestore, 'users', email));

        // 3. If doc exists, store user info, else just store email
        if (userDoc.exists()) {
          localStorage.setItem('currentUser', JSON.stringify({
            email,
            displayName: userDoc.data().name,
            planType: userDoc.data().planType
          }));
        } else {
          localStorage.setItem('currentUser', JSON.stringify({ email }));
        }

        window.localStorage.removeItem("emailForSignIn");
        navigate("/dashboard");
      } catch (err) {
        console.error("Erreur lors de la connexion:", err);
        setError(err.message);
      }
      */
    };

    handleSignIn();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      {error ? <p>{error}</p> : <p>Connexion en cours…</p>}
    </div>
  );
};

export default MagicLinkSignin;
